import React, { memo } from 'react';
import { CTAButton } from './Shared';
export const ProductIntroSection = () => {
  const bullets = ['Actividades organizadas por ciclos', 'Contenidos de diferentes áreas', 'Material descargable e imprimible', 'Evaluación y seguimiento', 'Aplicación sencilla', 'Acceso inmediato'];
  return <section className="bg-familia-lightBg py-10 md:py-16 px-4 md:px-6 text-familia-darkText" data-id="element-181">
      <div className="max-w-4xl mx-auto text-center w-[92%] md:w-full" data-id="element-182">
        <div className="inline-block bg-familia-electric text-white font-bold text-xs sm:text-sm px-4 sm:px-6 py-2 rounded-full mb-6 md:mb-8 uppercase tracking-wider shadow-md" data-id="element-183">
          📚 EL SISTEMA MUNDIALISTA PARA NIVEL PRIMARIO
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-extrabold mb-4 text-familia-bg" data-id="element-184">
          MUNDIAL EN EL AULA 360™
        </h2>

        <p className="text-familia-electric font-bold text-lg md:text-xl max-w-2xl mx-auto mb-6 leading-relaxed" data-id="element-185">
          Una planificación interdisciplinaria para trabajar de 1.º a 7.º grado
          utilizando el Mundial como hilo conductor.
        </p>

        <div className="text-familia-darkGray text-[14px] md:text-base max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed font-medium" data-id="element-186">
          <p className="mb-2 text-familia-bg font-bold" data-id="element-187">
            No recibís ideas sueltas.
          </p>
          <p data-id="element-188">
            Recibís una ruta clara para leer, escribir, calcular, investigar,
            interpretar datos, conocer países, trabajar valores y evaluar
            aprendizajes.
          </p>
        </div>

        <div className="bg-white border border-familia-electric/20 p-5 md:p-8 rounded-2xl mb-8 md:mb-12 shadow-md text-left max-w-3xl mx-auto" data-id="element-189">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6" data-id="element-190">
            {bullets.map((b, i) => <div key={i} className="flex items-start gap-3" data-id="element-191">
                <span className="text-familia-green text-lg shrink-0" data-id="element-192">✅</span>
                <span className="font-bold text-[13px] sm:text-[14px] text-familia-bg" data-id="element-193">
                  {b}
                </span>
              </div>)}
          </div>
        </div>

        <CTAButton href="#precio" className="w-full sm:w-auto text-base px-8 py-4" data-id="element-194">
          QUIERO ACCEDER AL MEGA PACK
        </CTAButton>
      </div>
    </section>;
};